var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copyIcon_svg__clip0_908_18249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9 3.6V1.2C3.9.54 4.485 0 5.2 0h6.5c.345 0 .675.126.92.351.243.226.38.53.38.849v6c0 .318-.137.623-.38.849a1.357 1.357 0 01-.92.351H9.1v2.4c0 .318-.137.623-.38.848A1.357 1.357 0 017.8 12H1.3c-.345 0-.675-.126-.92-.351A1.155 1.155 0 010 10.8v-6c0-.66.585-1.2 1.3-1.2h2.6zm1.3 0h2.6c.345 0 .675.126.92.351.243.226.38.53.38.849v2.4h2.6v-6H5.2v2.4zM1.3 4.8v6h6.5v-6H1.3z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copyIcon_svg__clip0_908_18249"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13v12H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/copyIcon.ad02d133.svg";
export { MemoForwardRef as ReactComponent };